import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/tocZQY/tips.png'
import _imports_1 from '../../../assets/tocZQY/zqy_268v_icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2f748ab5")

_pushScopeId("data-v-2f748ab5")
const _hoisted_1 = { class: "tocV3_headTip" }
const _hoisted_2 = { class: "tocV3_topText" }
const _hoisted_3 = { class: "tocV3_topText_flex" }
const _hoisted_4 = {
  key: 0,
  class: "brandlogo_wrapper"
}
const _hoisted_5 = { class: "tocV3_topText_one" }
const _hoisted_6 = {
  key: 1,
  class: "tocV3_topText_xny"
}
const _hoisted_7 = { class: "ptb5" }
const _hoisted_8 = { class: "tocV3_topText_small" }
const _hoisted_9 = { class: "tocV3_topText_small" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "tocV3_topText_small_shallow" }, "*车型信息仅供参考，请以实车为准", -1)
const _hoisted_11 = {
  key: 0,
  class: "tocV3_banner_cheKuang_main"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("b", null, "温馨提示：本报告检测内容仅供参考，不可直接作为车辆交易凭证。", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 如您参考此报告购车，268V不承担任何检测失误责任。 ")
const _hoisted_14 = {
  key: 1,
  class: "head_promise_result_wrap"
}
const _hoisted_15 = { class: "head_promise_wrapper" }
const _hoisted_16 = { class: "vector_description" }
const _hoisted_17 = { class: "result_wrap" }
const _hoisted_18 = { class: "proResCont" }
const _hoisted_19 = { class: "proTabs" }
const _hoisted_20 = { class: "proTabLine" }
const _hoisted_21 = { class: "proDesc" }
const _hoisted_22 = { class: "resBox_top" }
const _hoisted_23 = { class: "top_level" }
const _hoisted_24 = { class: "top_levelDes" }
const _hoisted_25 = { class: "resbox_bottom" }
const _hoisted_26 = { class: "rectangle_resBox" }
const _hoisted_27 = { class: "rectangle_resBox_item_txt" }
const _hoisted_28 = { class: "batteryCont" }
const _hoisted_29 = { class: "batteryItem" }
const _hoisted_30 = { class: "batteryNum" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("电池健康度")
const _hoisted_32 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_33 = { class: "batteryRes" }
const _hoisted_34 = { class: "batteryItem" }
const _hoisted_35 = { class: "batteryNum" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("充电接口状态")
const _hoisted_37 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_38 = { class: "batteryRes" }
const _hoisted_39 = { class: "result_bottom" }
const _hoisted_40 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_1
}, null, -1)
const _hoisted_41 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_42 = { class: "result_wrap" }
const _hoisted_43 = { class: "resBox_top" }
const _hoisted_44 = { class: "top_level" }
const _hoisted_45 = { class: "top_levelDes" }
const _hoisted_46 = { class: "resbox_bottom" }
const _hoisted_47 = { class: "rectangle_resBox" }
const _hoisted_48 = { class: "rectangle_resBox_item_txt" }
const _hoisted_49 = { class: "result_bottom" }
const _hoisted_50 = /*#__PURE__*/_createVNode("img", {
  class: "localIcon",
  src: _imports_1
}, null, -1)
const _hoisted_51 = { class: "toc_ui__headTip_content_report_num" }
const _hoisted_52 = { class: "buyCarTip" }
const _hoisted_53 = { class: "batteryTips" }
const _hoisted_54 = /*#__PURE__*/_createVNode("h4", null, "电池健康度", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 1、SOH≥85%：电池健康度良好；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2、75%≤SOH＜85%：电池健康度一般；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3、SOH＜75%：电池健康度较差。"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 备注：动力电池SOH实测数值为百分比，动力电池评级展示时只展示百分比前方数值。 ")
], -1)
const _hoisted_56 = { class: "batteryTips" }
const _hoisted_57 = /*#__PURE__*/_createVNode("h4", null, "充电接口状态", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" A：充电接口使用情况良好；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" B：充电接口使用情况一般；"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" C：充电接口使用情况较差。 ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.state.brandLogo && _ctx.state.brandLogo.length)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode("img", {
                  src: _ctx.state.brandLogo,
                  class: "tocV3_topText_brandlogo"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.state.brandName), 1),
          (_ctx.state.isXNY)
            ? (_openBlock(), _createBlock("div", _hoisted_6, "新能源"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, [
            (_ctx.state.productName && _ctx.state.productName.length)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["productname_wrapper productname_bg", {"productname_bg_499": (_ctx.state.reportMsg.Rp499()||_ctx.state.reportMsg.RpZQYS()),"productname_bg_699": _ctx.state.reportMsg.Rp699(),"productname_bg_hc": _ctx.state.reportMsg.RpHC()}]
                }, [
                  _createVNode("span", {
                    class: ["productname_font productname", {"productname_499": (_ctx.state.reportMsg.Rp499()||_ctx.state.reportMsg.RpZQYS()),"productname_699": _ctx.state.reportMsg.Rp699(),"productname_hc": _ctx.state.reportMsg.RpHC()}]
                  }, _toDisplayString(_ctx.state.productName), 3)
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.state.modelName), 1),
        _createVNode("div", _hoisted_9, "VIN: " + _toDisplayString(_ctx.state.vin), 1),
        _hoisted_10
      ]),
      (_ctx.state.reportMsg.RpCK())
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("img", {
              src: require('../../../assets/tocV3/tipIcon.png')
            }, null, 8, ["src"]),
            _hoisted_12,
            _hoisted_13
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_14, [
            (_ctx.state.isSF)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["head_promise_bg", _ctx.getHeadPromiseBgStyle()],
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.reportMsg.RpSRZ()? _ctx.setShowProtect() : _ctx.toExplain('check')))
                }, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("img", {
                        class: "vector",
                        src: _ctx.getVectorIcon(),
                        alt: ""
                      }, null, 8, ["src"]),
                      _createVNode("span", {
                        class: ["promiseMsg", _ctx.getPromiseMsgFont()]
                      }, _toDisplayString(_ctx.state.promiseMsg), 3)
                    ]),
                    _createVNode("img", {
                      class: "headArrowRight",
                      src: _ctx.getRightArrowIcon(),
                      alt: ""
                    }, null, 8, ["src"])
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (_ctx.state.reportMsg.RpZQYS())
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: ["head_result_bg", _ctx.getHeadResultBgStyle()]
                }, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", {
                          class: ["proTab_item", {"active" : _ctx.state.tabIndex === 0}],
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab(0)))
                        }, [
                          _createVNode("span", null, "车况检测" + _toDisplayString(_ctx.state.rank), 1)
                        ], 2),
                        _createVNode("div", _hoisted_20, [
                          _createVNode("div", {
                            class: ["proTabLineCont", {"proTabLine1" : _ctx.state.tabIndex === 0, "proTabLine2" : _ctx.state.tabIndex === 1}]
                          }, null, 2)
                        ]),
                        _createVNode("div", {
                          class: ["proTab_item", {"active" : _ctx.state.tabIndex === 1}],
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTab(1)))
                        }, [
                          _createVNode("span", null, "电池检测" + _toDisplayString(_ctx.state.soh) + _toDisplayString(_ctx.state.chargeVoc), 1)
                        ], 2)
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("div", {
                          class: ["result_middle", {"result_middle_nosf": !_ctx.state.isSF}]
                        }, [
                          _createVNode("div", _hoisted_22, [
                            _createVNode("div", _hoisted_23, [
                              _createVNode("img", {
                                class: "levelIcon",
                                src: _ctx.getResBoxLevelIcon(),
                                alt: ""
                              }, null, 8, ["src"]),
                              _withDirectives(_createVNode("img", {
                                class: "jiIcon",
                                src: _ctx.getResJiStyleIcon(),
                                alt: ""
                              }, null, 8, ["src"]), [
                                [_vShow, _ctx.state.rank !== null && _ctx.state.rank !== undefined]
                              ])
                            ]),
                            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.state.rankDesc), 1)
                          ]),
                          _createVNode("div", _hoisted_25, [
                            _createVNode("ul", _hoisted_26, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportResultList, (item, index) => {
                                return (_openBlock(), _createBlock("li", {
                                  class: "rectangle_resBox_item",
                                  key: index
                                }, [
                                  _createVNode("img", {
                                    src: item.isErr === 0 ? item.baseSrc : (item.isErr === 1 ? item.src : item.otherSrc),
                                    alt: ""
                                  }, null, 8, ["src"]),
                                  _createVNode("div", null, [
                                    _createVNode("p", _hoisted_27, _toDisplayString(item.name), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 2), [
                          [_vShow, _ctx.state.tabIndex === 0]
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_28, [
                          _createVNode("div", _hoisted_29, [
                            _createVNode("div", _hoisted_30, [
                              _withDirectives(_createVNode("img", {
                                class: "batteryImg",
                                src: _ctx.sohImg()
                              }, null, 8, ["src"]), [
                                [_vShow, _ctx.sohImg()]
                              ]),
                              _createVNode("span", null, _toDisplayString(_ctx.state.soh), 1)
                            ]),
                            _createVNode("p", {
                              class: "batteryTips",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowBattery("showBatteryStatus")))
                            }, [
                              _hoisted_31,
                              _hoisted_32
                            ]),
                            _createVNode("p", _hoisted_33, _toDisplayString(_ctx.state.sohDesc), 1)
                          ]),
                          _createVNode("div", _hoisted_34, [
                            _createVNode("div", _hoisted_35, [
                              _withDirectives(_createVNode("img", {
                                class: "powerImg",
                                src: _ctx.chargeVocImg()
                              }, null, 8, ["src"]), [
                                [_vShow, _ctx.chargeVocImg()]
                              ]),
                              _createVNode("span", null, _toDisplayString(_ctx.state.chargeVoc), 1)
                            ]),
                            _createVNode("p", {
                              class: "batteryTips",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setShowBattery("showPowerStatus")))
                            }, [
                              _hoisted_36,
                              _hoisted_37
                            ]),
                            _createVNode("p", _hoisted_38, _toDisplayString(_ctx.state.chargeVocDesc), 1)
                          ])
                        ], 512), [
                          [_vShow, _ctx.state.tabIndex === 1]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode("span", _hoisted_41, " NO." + _toDisplayString(_ctx.state.reportCode), 1)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createBlock("div", {
                  key: 2,
                  class: ["head_result_bg", _ctx.getHeadResultBgStyle()]
                }, [
                  _createVNode("div", _hoisted_42, [
                    _createVNode("div", {
                      class: ["result_middle", {"result_middle_nosf": !_ctx.state.isSF}]
                    }, [
                      _createVNode("div", _hoisted_43, [
                        _createVNode("div", _hoisted_44, [
                          _createVNode("img", {
                            class: "levelIcon",
                            src: _ctx.getResBoxLevelIcon(),
                            alt: ""
                          }, null, 8, ["src"]),
                          _withDirectives(_createVNode("img", {
                            class: "jiIcon",
                            src: _ctx.getResJiStyleIcon(),
                            alt: ""
                          }, null, 8, ["src"]), [
                            [_vShow, _ctx.state.rank !== null && _ctx.state.rank !== undefined]
                          ])
                        ]),
                        _createVNode("div", _hoisted_45, _toDisplayString(_ctx.state.rankDesc), 1)
                      ]),
                      _createVNode("div", _hoisted_46, [
                        _createVNode("ul", _hoisted_47, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportResultList, (item, index) => {
                            return (_openBlock(), _createBlock("li", {
                              class: "rectangle_resBox_item",
                              key: index
                            }, [
                              _createVNode("img", {
                                src: item.isErr === 0 ? item.baseSrc : (item.isErr === 1 ? item.src : item.otherSrc),
                                alt: ""
                              }, null, 8, ["src"]),
                              _createVNode("div", null, [
                                _createVNode("p", _hoisted_48, _toDisplayString(item.name), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 2),
                    _createVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _createVNode("span", _hoisted_51, " NO." + _toDisplayString(_ctx.state.reportCode), 1)
                    ])
                  ])
                ], 2)),
            _createVNode(_component_van_popup, {
              show: _ctx.state.showProtect,
              "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.showProtect = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_52, [
                  _createVNode("p", {
                    class: "buyCarTipItem",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toExplain('check')))
                  }, _toDisplayString(_ctx.state.showPromiseDes), 1),
                  (_ctx.state.reportMsg.RpSRZ())
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        class: "buyCarTipItem",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.toExplain('auth')))
                      }, " 查看《付费享1年3万公里保修说明》 "))
                    : _createCommentVNode("", true),
                  _createVNode("p", {
                    class: "canbutton",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setShowProtect()))
                  }, "取消")
                ])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_popup, {
              show: _ctx.state.showBatteryStatus,
              "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.showBatteryStatus = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _hoisted_55,
                  _createVNode("div", {
                    class: "canbutton",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setShowBattery("showBatteryStatus")))
                  }, "知道了")
                ])
              ]),
              _: 1
            }, 8, ["show"]),
            _createVNode(_component_van_popup, {
              show: _ctx.state.showPowerStatus,
              "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.showPowerStatus = $event)),
              round: "",
              position: "bottom"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _hoisted_58,
                  _createVNode("div", {
                    class: "canbutton",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setShowBattery("showPowerStatus")))
                  }, "知道了")
                ])
              ]),
              _: 1
            }, 8, ["show"])
          ]))
    ])
  ]))
})